import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function useSiteBanner() {
  const { user } = useAuth();
  const [banner, setBanner] = useState({ enabled: false, message: "" });

  useEffect(() => {
    if (!user) return;
    const load = () => api.get("/admin/maintenance-mode").then(({ data }) => setBanner(data)).catch(() => {});
    load();
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
  }, [user]);

  return banner;
}
